const store = {
  modules: {
    cart: {
      namespaced: true,
      state: {
        data: {},
        open: false,
      },
      actions: {
        toggleCart: function () {},
      },
    },
  },
};

export default store;
